import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

import styles from "./report.module.css";
import * as messageAction from "../../../../../actions/Message";
import { useSocket } from "../../../../../Context/SockerContext";

const ReportModal = ({ personId, show, setShow }) => {
  const navigate = useNavigate();
  const [options, setOptions] = useState([]);
  const [selectedReason, setSelectedReason] = useState(null);
  const [isConfirmStep, setIsConfirmStep] = useState(false);
  const { socket } = useSocket();
  const formRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    (async () => {
      const response = await messageAction.getReportReason();
      if (response) {
        setOptions(response);
      }
    })();
    // Reset when modal opens
    setIsConfirmStep(false);
    setSelectedReason(null);
  }, [show]);

  const handleInitialSubmit = e => {
    e.preventDefault();
    const reason = new FormData(formRef.current).get("reportId");
    if (!reason) return;
    setSelectedReason(reason);
    setIsConfirmStep(true);
  };

  const handleConfirmSubmit = async () => {
    const body = JSON.stringify({
      personId: personId,
      reportId: selectedReason,
    });
    const response = await messageAction.updateReportReason(body);
    if (response) {
      socket?.emit("leave-room", sessionStorage.getItem("conversationId"));
      sessionStorage.removeItem("conversationId");
      navigate("/user/chat/matches");
    }
  };

  return (
    <Modal className={styles.customer_modal} size="sm" centered show={show}>
      <Modal.Body>
        {!isConfirmStep ? (
          <>
            <p className={styles.heading}>Report user?</p>
            <p className={styles.subtext}>
              Sure you’d like to report? Help us understand why.
            </p>
            <form
              ref={formRef}
              onSubmit={handleInitialSubmit}
              className={styles.form}
            >
              {options.map(option => (
                <label
                  key={option.id}
                  htmlFor={option.id}
                  className={styles.label}
                >
                  <input
                    type="radio"
                    name="reportId"
                    id={option.id}
                    value={option.id}
                    className={styles.radio}
                  />
                  <span>{option.name}</span>
                </label>
              ))}
            </form>
            <div className={styles.buttons}>
              <button
                type="button"
                className="global-cancel-button"
                onClick={() => setShow(false)}
              >
                Close
              </button>
              <button
                type="submit"
                className="global-save-button"
                onClick={() => formRef.current?.requestSubmit()}
              >
                Submit
              </button>
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center" }}>
            <p className={styles.heading}>Confirm Report</p>
            <p style={{ fontSize: "16px", color: "#6c6c6c" }}>
              Are you sure you want to report this user for selected reason?
            </p>
            <div className={styles.buttons}>
              <button
                type="button"
                className="global-cancel-button"
                onClick={() => setIsConfirmStep(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="global-save-button"
                onClick={handleConfirmSubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ReportModal;
